import React from 'react'
import EyeMedFormButton from '../EyeMedFormButton'
import FrameFormFields from './FrameFormFields'
import FrameDocuments from './FrameDocuments'

export default function FrameStep2(props) {
  const { claimFormTemplate, submitEyeMedClaimForm, visionInsuranceClaimForm } = props
  const frameFields = claimFormTemplate?.config?.frames || []

  return (
    <>
      <div className='row'>
        <FrameFormFields frameFields={frameFields} />
        <FrameDocuments visionInsuranceClaimForm={visionInsuranceClaimForm} submitEyeMedClaimForm={submitEyeMedClaimForm} />
        <p className='mb-4 col-12'>
          A default diagnosis code will be provided if you're not submitting an eye exam claim. You can enter other diagnosis codes as needed in the Other Diagnosis field.
        </p>
        <p className='mb-4 col-12'>
          <strong>Frame Attestation:</strong> I acknowledge and understand EyeMed does not provide payment for materials or charges arising from tinted or clear non-prescription lenses (collectively, "Plano Lenses") and hereby attest to the following additional information regarding the frames that were dispensed under the above-referenced claim number:
        </p>
        <h6 className='mb-5 col-12'>
          **If this claim is a resubmission for a previously denied frame only claim, you must instead submit the claim via paper with a note at the top of the claim that says 'FRAME ONLY'.**
        </h6>
      </div>
      <EyeMedFormButton currentModule="Frame" />
    </>
  )
}
